import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=a7aedb78&"
import script from "./BaseNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports